import { X } from 'lucide-react';
import Dropdown from '@/ui/dropdown/Dropdown';
import OutsideClickHandler from '@/shared/OutsideClickHandler';
import { FloatingTextinput } from '@/ui/floating-textinput/floating-textinput';
import { twColors } from '@/utils/tw-colors';
import s from '@/components/orders/new-order/live.module.css';

export const ShopSearchBox = ({
	isOperating,
	isMasterOrAdmin,
	selectedShop,
	size,
	shopSearchText,
	onShopSearch,
	onFocusShop,
	setNewOrderMobileVisible,
	setShopSearchText,
	dropdownShopRef,
	onShopSelect,
	foundShops,
}) => {
	if (!isOperating || !isMasterOrAdmin || selectedShop) return null;

	return (
		<div
			className='flex flex-row items-center gap-x-2'
			style={{
				position: 'absolute',
				right: 0,
				height: 38,
				marginTop: size.width > 1120 ? 15 : -1,
				fontSize: 15,
				lineHeight: 1.1,
			}}
		>
			<div className={s.clientSearch}>
				<FloatingTextinput
					value={shopSearchText}
					label={`${size.width > 599 ? 'Αναζήτηση' : 'Αναζ.'} Καταστήματος`}
					onChange={e => onShopSearch(e)}
					onFocus={onFocusShop}
					styleContainer={{ width: '100%', maxWidth: size.width < 500 ? 190 : 214 }}
					rightComponents={
						shopSearchText
							? [
									{
										key: 'x-button',
										onClick: () => {
											setNewOrderMobileVisible(false);
											setShopSearchText('');
										},
										component: <X color={twColors.orange[600]} size={24} />,
									},
								]
							: []
					}
				/>

				<OutsideClickHandler
					onOutsideClick={() => dropdownShopRef.current.parentToggleModal(false)}
				>
					<Dropdown ref={dropdownShopRef} onChange={onShopSelect} options={foundShops} />
				</OutsideClickHandler>
			</div>
		</div>
	);
};
